"use client";

import * as React from "react";
import { Check, ArrowRight, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = ["Flexibler Zugang 24/7 zu Ihrem Arbeitsplatz", "High-Speed  Internet inklusive", "Kaffee, Tee und Wasser Flatrate", "Nutzung moderner Meetingräume", "Professioneller Post- und Paketservice", "Einladung zu exklusiven Community Events"];
export default function PurchaseOffer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}